import React, { Profiler, cloneElement, useState } from "react";
import toast from "react-hot-toast";
import { Button, TextField } from "@mui/material";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { useParams } from "react-router-dom";
import services from "../../services";

// import withReactContent from 'sweetalert2-react-content'
export default function ProximityForm({
  setAddProximityOpen,
  setIsProximityAdded,
  setIsProximityUpdated,
  BuildingId,
  setLoading,
  loading,
  filteredData,
  setOpen,
}) {
  const { id } = useParams();
  const [name, setName] = useState(
    filteredData?.name ? filteredData?.name : ""
  );
  const [serial, setSerial] = useState(
    filteredData?.serial ? filteredData?.serial : ""
  );
  const [code, setCode] = useState(
    filteredData?.code ? filteredData?.code : ""
  );
  const [entrance, setEntrance] = useState(
    filteredData?.entrance ? filteredData?.entrance : "0"
  );

  const handleRadioChange = (event) => {
    setEntrance(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const regex = /^[0-9]+$/;

    if (!name || !serial || !code) {
      toast.error("All fields are required");
      return;
    } else if (!regex.test(serial)) {
      toast.error("Serial should be only number");
      return;
    }

    const formData = {
      name: name,
      serial: serial,
      entrance: entrance,
      code: code,
      building: id,
    };

    if (filteredData?.ix) {
      services
        .editProximity(formData, filteredData?.ix)
        .then((res) => {
          toast.success(res.message);
          setOpen(null);
          if (res) {
            window.location.reload();
          }
        })

        .catch((err) => console.log(err.response));
    } else {
      setLoading(true);
      services
        .addProximity(formData)
        .then((res) => {
          toast.success(res.message);
          setIsProximityAdded(res);
          setName("");
          setLoading(false);
          setAddProximityOpen(false);
        })
        .catch((err) => {
          console.log(err.response);
          setLoading(false);
        });
    }
  };

  return (
    <form className="add-user-form" onSubmit={handleSubmit}>
      <div>
        <InputLabel for="profile">Name</InputLabel>
        <TextField
          fullWidth
          name="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div>
        <InputLabel for="user">Code</InputLabel>
        <TextField
          fullWidth
          name="code"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
      </div>

      <div>
        <InputLabel for="user">Serial</InputLabel>
        <TextField
          fullWidth
          name="serial"
          type="text"
          value={serial}
          onChange={(e) => setSerial(e.target.value)}
        />
      </div>
      <div>
        {/* Radio button group */}

        <InputLabel>Entrance</InputLabel>
        <RadioGroup
          row
          name="isTrue"
          value={entrance}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="1" control={<Radio />} label="True" />
          <FormControlLabel value="0" control={<Radio />} label="False" />
        </RadioGroup>
      </div>
      <Button
        disabled={loading}
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
      >
        Submit
      </Button>
    </form>
  );
}
